import { CONTACT, LOGO } from "../../lib/data";
import { scrollToId } from "../../lib/scroll";
import { useLang } from "../../i18n";

export const Footer = () => {
  const { c } = useLang();
  const go = (href) => scrollToId(href);
  return (
    <footer data-testid="site-footer" className="bg-[var(--bg-primary)] border-t border-[var(--border)] py-16">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <img src={LOGO} alt="Ancion Consulting" className="h-36 md:h-44 w-auto object-contain -ml-2" />
            <p className="font-sans text-[var(--text-secondary)] mt-4 max-w-sm leading-relaxed">
              {c.footer.tagline}
            </p>
          </div>
          <div className="md:col-span-3">
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--accent)]">{c.footer.navigate}</span>
            <ul className="mt-5 flex flex-col gap-3">
              {c.nav.fullMenu.map((l) => (
                <li key={l.href}>
                  <button data-testid={`footer-link-${l.href.slice(1)}`} onClick={() => go(l.href)} className="font-sans text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--accent)]">{c.footer.contact}</span>
            <ul className="mt-5 flex flex-col gap-3 font-sans text-[var(--text-secondary)]">
              <li><a href={`mailto:${CONTACT.email}`} className="hover:text-[var(--text-primary)] transition-colors">{CONTACT.email}</a></li>
              <li><a href={`tel:${CONTACT.phone}`} className="hover:text-[var(--text-primary)] transition-colors">{CONTACT.phone}</a></li>
              <li>{CONTACT.location}</li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-[var(--border)] flex flex-col md:flex-row justify-between gap-4 font-mono text-xs text-[var(--text-secondary)] uppercase tracking-[0.15em]">
          <span>© {new Date().getFullYear()} Ancion Consulting</span>
          <span>{c.footer.geo}</span>
        </div>
      </div>
    </footer>
  );
};
